import React, { forwardRef, ReactElement } from "react";

import {
  StyledValueButton,
  StyledValueButtonLabel,
  StyledValueButtonValue,
} from "./Styles";

export interface IValueButtonProps {
  /** Set active state */
  active?: boolean;
  /** Label for value */
  label?: string;
  /** Value */
  value: string;
  /** Icon */
  icon?: ReactElement;
  /** Always show icon */
  alwaysShowIcon?: boolean;
}

export const ValueButton = forwardRef<HTMLButtonElement, IValueButtonProps>(
  (
    { active = false, alwaysShowIcon = false, icon, label, value, ...args },
    ref
  ) => {
    return (
      <StyledValueButton
        className="c-value-button"
        {...args}
        ref={ref}
        variant="text gray"
        $active={active}
      >
        {icon && alwaysShowIcon
          ? React.cloneElement(icon, {
              style: { display: "inline-block" },
            })
          : null}
        {label ? (
          <StyledValueButtonLabel
            color="secondary"
            weight="medium"
            className="c-value-button__label"
          >
            {label}:
          </StyledValueButtonLabel>
        ) : null}
        <StyledValueButtonValue
          color="secondary"
          weight="medium"
          className="c-value-button__value"
        >
          {value}
        </StyledValueButtonValue>
      </StyledValueButton>
    );
  }
);

ValueButton.displayName = "ValueButton";
